// src/pages/Home.jsx
import React from 'react';
import styles from './Home.module.css'; // Keep this for overall page wrapper/global styles

// Import your new section components
import HeroSection from '../components/home/HeroSection';
import WhyChooseUsSection from '../components/home/WhyChooseUsSection';
import AnimatedCounts from '../components/includes/AnimatedCounts';
import CoursesSection from '../components/home/CoursesSection';
import CompanyLogosSlider from '../components/includes/CompanyLogosSlider'; // Existing component
import TestimonialsSection from '../components/home/TestimonialsSection';
import EnrollmentCTASection from '../components/home/EnrollmentCTASection';
import FAQ from '../components/includes/FAQ';
const Home = ({setIsPopupVisible}) => {
  return (
    <div className={styles.home}> {/* This wrapper can stay if you have global page styles */}
      <HeroSection />
      <WhyChooseUsSection />
   
      <CoursesSection />
      <CompanyLogosSlider />
      <TestimonialsSection />
      <FAQ />
       <EnrollmentCTASection setIsPopupVisible={setIsPopupVisible} />
      
    </div>
  );
};

export default Home;